module.exports = __webpack_public_path__ + "img/Maestro.2fb07303.svg";